import React from 'react';
import UserManagement from './UserManagement';

export default function UserManagementContainer() {
  return <UserManagement />;
}
